import React, { PropsWithChildren } from "react";

import cn from "classnames";
import css from '../../styles/styles.module.css';

export const ContentBlock: React.FC<PropsWithChildren> = ({ children }: PropsWithChildren) => {
    return <div className={cn(css["content-wrapper"])} data-testid="ContentBlock">
        {children}
    </div>
}